import { useCallback, useMemo, useState } from "react";
import { localStorageTest, persistJwtToken } from "../utils";

/**
 * Read the account JWT token from localStorage. Use this in conjunction with `useAccountMagicLinkToken` for login.
 * If you receive a valid JWT token, you can safely use it in your application (e.g. save in state management), but
 * be aware, that the token can have an expire date, too.
 */
function useAccountJwtToken(localStorageName) {
  const canLocalStorage = useMemo(() => localStorageTest(), []);
  const [jwt, setJwt] = useState(canLocalStorage ? localStorage.getItem(localStorageName) || undefined : window[localStorageName]);
  const saveJwt = useCallback(jwt => {
    if (localStorageName) {
      persistJwtToken(localStorageName, jwt);
    }
    setJwt(jwt);
  }, []);
  return {
    jwt,
    saveJwt
  };
}
export { useAccountJwtToken };